import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  MdDashboard,
} from "react-icons/md";
import {
  FaTasks,
  FaCloudUploadAlt,
  FaSignOutAlt,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import Source from "./SourceIMG.png";
import ProfileIMG from "./Profilpic.jpg";
import { IoSettings } from "react-icons/io5";

const Layout = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  // const isAdmin = sessionStorage.getItem("userRole") === "Admin";/
  const userRole = sessionStorage.getItem("userRole");
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <MdDashboard size={36} /> },
    { name: "Task", path: "/task", icon: <FaTasks size={36} /> },
    { name: "My Data", path: "/mydata1", icon: <FaCloudUploadAlt size={36} /> },
    { name: "Setting", path: "/", icon: <IoSettings size={36} /> },
  ];
  const handleMenuClick = (item) => {
    console.log("Menu clicked:", item.name);

    // If you specifically want PlayBook click log
    if (item.name === "PlayBook") {
      console.log("PlayBook button clicked!");
    }

    history.push(item.path);
  };

  return (
    <div className="w-full h-screen bg-gray-100 flex relative">
      <aside
        className={`${collapsed ? "w-36" : "w-56 "
          } bg-[#1E5045]  text-[#FECF8B] p-4 flex flex-col justify-between shadow-lg transition-all duration-300`} >
        <div className="space-y-6">
          <div className="flex items-center justify-between mb-8">
            {!collapsed && (
              <img
                src={Source}
                alt="Logo"
                className="header-logo"
                style={{ width: "250px" }}
              />
            )}
            <button
              onClick={() => setCollapsed(!collapsed)}
              className="text-[#1E5045]  bg-[#FECF8B]  p-2 rounded-s-lg"
            >
              {collapsed ? (
                <FaChevronRight size={20} />
              ) : (
                <FaChevronLeft size={20} />
              )}
            </button>
          </div>

          {/* Menu */}
          {(userRole === "Admin" || userRole === "Customer") && (
            <div className="space-y-2">
              {menuItems.map((item) => {
                const active = location.pathname === item.path;

                return (
                  <div key={item.name} className="relative group">
                    <button
                      className={`flex items-center w-full px-3 py-2 font-semibold transition duration-200 rounded 
              ${active
                          ? "bg-[#FECF8B] text-[#1E5045] hover:bg-[#FFD77D]"
                          : "hover:text-orange-400"
                        }`}
                      onClick={() => handleMenuClick(item)}
                    >
                      {item.icon}
                      {!collapsed && <span className="ml-3">{item.name}</span>}
                    </button>

                    {collapsed && (
                      <span
                        className="absolute left-14 top-1/2 transform -translate-y-1/2 
                bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                      >
                        {item.name}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Logout */}
        <div className="relative group">
          <div className="flex items-center space-x-1 p-2 rounded-xl w-full">
            <img
              src={ProfileIMG}
              alt="User Avatar"
              className="w-12 h-12 rounded-full border border-gray-300"
            />
            {!collapsed && (
              <div>
                <p className="font-semibold text-white">{sessionStorage.getItem("userName") || "User"}</p>
                <p className="text-sm text-gray-300">
                  {sessionStorage.getItem("userEmail") || "user@example.com"}
                </p>
              </div>
            )}
          </div>
          <button
            className="flex items-center px-3 py-2 hover:text-red-400 text-lg font-semibold rounded"
            onClick={() => history.push("/login")}
          >
            <FaSignOutAlt size={28} className="mr-3" />
            {!collapsed && "Logout"}
          </button>

          {/* Tooltip for logout */}
          {collapsed && (
            <span
              className="absolute left-14 top-1/2 transform -translate-y-1/2 
              bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
            >
              Logout
            </span>
          )}
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 flex flex-col h-screen p-6 overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default Layout;
